module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.customClass
  }, [_vm._t("consent"), _vm._v(" "), _vm._t("notes"), _vm._v(" "), (_vm.tos_enabled) ? _c('div', {
    staticClass: "cb-subscribe",
    class: {
      'cb-subscribe--left': _vm.$slots['consent'] && _vm.tos_holder.show_checkbox
    }
  }, [(_vm.tos_holder.show_checkbox) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tos_agreed),
      expression: "tos_agreed"
    }],
    ref: "x",
    staticClass: "cb-subscribe__check",
    attrs: {
      "type": "checkbox",
      "id": "tos_agreed"
    },
    domProps: {
      "checked": Array.isArray(_vm.tos_agreed) ? _vm._i(_vm.tos_agreed, null) > -1 : (_vm.tos_agreed)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.next()
      },
      "__c": function($event) {
        var $$a = _vm.tos_agreed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.tos_agreed = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.tos_agreed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.tos_agreed = $$c
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.transformedContent && _vm.transformedContent.parts) ? _c('label', {
    staticClass: "cb-subscribe__label",
    class: {
      'cb-subscribe__label--mandatory': _vm.$slots['consent'] && _vm.is_tos_cbx_showed
    },
    attrs: {
      "for": "tos_agreed"
    }
  }, [(_vm.transformedContent.parts[0]) ? _c('span', {
    directives: [{
      name: "cb-html",
      rawName: "v-cb-html",
      value: (_vm.sanitizeLineBreaks(_vm.transformedContent.parts[0])),
      expression: "sanitizeLineBreaks(transformedContent.parts[0])"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.transformedContent.labels[0]) ? _c('a', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('color'),
      expression: "'color'"
    }],
    staticClass: "cb-subscribe__link",
    attrs: {
      "href": _vm.url(_vm.transformedContent.labels[0]),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.label(_vm.transformedContent.labels[0])))]) : _vm._e(), _vm._v(" "), (_vm.transformedContent.parts[1]) ? _c('span', {
    directives: [{
      name: "cb-html",
      rawName: "v-cb-html",
      value: (_vm.sanitizeLineBreaks(_vm.transformedContent.parts[1])),
      expression: "sanitizeLineBreaks(transformedContent.parts[1])"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.transformedContent.labels[1]) ? _c('a', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('color'),
      expression: "'color'"
    }],
    staticClass: "cb-subscribe__link",
    attrs: {
      "href": _vm.url(_vm.transformedContent.labels[1]),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.label(_vm.transformedContent.labels[1])))]) : _vm._e(), _vm._v(" "), (_vm.transformedContent.parts[2]) ? _c('span', {
    directives: [{
      name: "cb-html",
      rawName: "v-cb-html",
      value: (_vm.sanitizeLineBreaks(_vm.transformedContent.parts[2])),
      expression: "sanitizeLineBreaks(transformedContent.parts[2])"
    }]
  }) : _vm._e()]) : _c('label', {
    staticClass: "cb-subscribe__label",
    class: {
      'cb-subscribe__label--mandatory': _vm.$slots['consent'] && _vm.is_tos_cbx_showed
    },
    attrs: {
      "for": "tos_agreed"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.tos_holder.txt) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.btn_hide) ? _c('cb-button', {
    class: {
      'cb-button__disabled': _vm.btn_disabled
    },
    attrs: {
      "custom-class": 'primary',
      "show-loader": _vm.showLoader,
      "aria-disabled": _vm.disableButton,
      "btnDisabled": _vm.disableButton,
      "disabled": _vm.disableButton,
      "attr": 'review_submit'
    },
    on: {
      "next": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.getButtonTxt) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.btn_hide) ? _c('div', {
    staticClass: "cb-subscribe cb-subscribe__footer"
  }, [_c('i', {
    staticClass: "icon-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n  " + _vm._s(_vm.st('checkout_message')) + " "), (!_vm.hideBranding) ? [_vm._v(_vm._s(_vm.st('chargebee_checkout')))] : _vm._e()], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f356b0fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/CheckoutSubscribeButton.vue
// module id = 153
// module chunks = 28 29 38 66 68 69